import type {
  SupplierHealth,
  SupplierStatus,
} from "@shared-core/data/purchase-ledger-types";
import { SUPPLIER_STATUS_LABELS } from "@shared-core/domain/supplier-record";
import { Badge } from "../../primitives/badge";

/** The supplier's status. On hold is a payment hold set in CIS: don't pay yet. */
export function SupplierStatusPill({ status }: { status: SupplierStatus }) {
  const variant =
    status === "active"
      ? "success"
      : status === "on_hold"
        ? "warning"
        : "neutral";
  return (
    <Badge variant={variant} className="font-normal">
      {SUPPLIER_STATUS_LABELS[status]}
    </Badge>
  );
}

/** The most urgent thing on the account; nothing when nothing is. */
export function SupplierHealthPill({
  health,
}: {
  health: SupplierHealth | null;
}) {
  if (!health) return null;
  return (
    <Badge variant={health.tone} className="font-normal">
      {health.label}
    </Badge>
  );
}
